import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import { getOptionsForAttr } from './coderefs';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function PIPWorkLossSelector({attr, additionalOptions, dataType, workflow, ...props}) {

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  const formContext = useContext(FormContext);
  let attribute = formContext.metadata[attr];

  let lineOptions = getOptionsForAttr(attribute).list;

  if (additionalOptions && additionalOptions.length) {
    lineOptions = [...lineOptions, ...additionalOptions];
  }

  const drivers = applicationModel.getValue('drivers');
  let driversLength = 0;
  if( drivers != undefined) {
    driversLength = drivers.filter(driver => {
                          return driver.status === 'Active' && parseInt(driver.personInfo.age) >= 60;
                        }).length;
  }

  if(dataType && dataType === 'SelectUpdate'){
    let selected = null;
    let children = lineOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>);
    const options = React.Children.map(children, el => {
        if (!el.props) {
          return null;
        }
        const obj = {
          label: el.props.children,
          value: el.props.value
        };
        if (el.props.value === props.value) {
          selected = obj;
        }
        if (workflow === "quote" || driversLength == 0){
            if(line.pIPBenefitCoordinationType == "Both Allowable Medical Expenses (Excl. Medicare) and Work Loss" || line.pIPBenefitCoordinationType == "Only Work Loss"){
              if (obj.value === "Yes"){
                if( selected != undefined && selected.value === "Yes" ){
                  selected = "No";
                }
                return null;
              }
            }
        }
        return obj;
    });

    let disabled = false;
    if(line.pIPBenefitCoordinationType == "Both Allowable Medical Expenses (Excl. Medicare) and Work Loss"
    || line.pIPBenefitCoordinationType == "Only Work Loss"){
        line.pIPWorkLossRejectionInd = "No";
      disabled = true;
    }

    const form = useContext(FormContext);
    const actions = useContext(ApplicationActionsContext);
    const { setValueByAttr, getValueByAttr } = form;
    const previousValue = selected;
    const [selectedValue, setSelectedValue] = useState(previousValue);

    const handleChange = (selected) => {
      setValueByAttr(attr, selected.value);
      setSelectedValue(selected);
      actions.saveApplication();
    };

    return <Select
        {...props}
        aria-label="Select"
        isDisabled={disabled}
        styles={customStylesUpdater}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={options}
        value={selected}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
  }
  return <PortalSelect {...props}>
    {
      lineOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

PIPWorkLossSelector.schema = BASIC_ELEMENT_SCHEMA;